import AbsSection from './AbsSection';

export default class SecLive extends AbsSection{
    constructor(_container='', _dataM={}, _option={}){
        super(_container, _dataM, _option, 'live');

        if( this.isShow ) {
            if( this.useManualData ){
                // this.dataM.addManual(this.alias, this.com.ip + '_mainOnOff');
                this.dataM.addCall(this.alias, {path: "/v1/videos/main?" + $.param({videoIds: _option.manualDataIds.join()})});
            } else {
                this.dataM.addCall(this.alias, {path: "/v1/videos/main/live?" + $.param({game: this.com.ip, page: 1, pageSize:3, order:'pop'})});
            }
        }
    }

    setTemplate(){
        let cardData = this.dataM.data.live;

        if(typeof cardData === 'string' || cardData.length<3){
            $(this.container).hide();
            return false;
        }

        let list = cardData.map( item => this.cardItemTmpl(item, this.alias, 'A') ).join('');
        $( this.container + ' .main-section-body .main-live-list' ).html( list );
    }


} // end of class
